import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './GracePeriodBanner.css';

const GracePeriodBanner: React.FC = () => {
  const { userProfile } = useAuth();
  const navigate = useNavigate();

  if (userProfile?.accountStatus !== 'grace_period') {
    return null;
  }

  const daysRemaining = userProfile.gracePeriodEndDate
    ? Math.max(0, Math.ceil(
        (new Date(userProfile.gracePeriodEndDate).getTime() - Date.now()) / (1000 * 60 * 60 * 24)
      ))
    : 0;

  return (
    <Alert variant="warning" className="grace-period-banner mb-0">
      <div className="grace-period-content">
        <div className="grace-period-text">
          <strong>Account in View-Only Mode</strong>
          <span className="grace-period-message">
            Your subscription has been canceled. You have {daysRemaining} day{daysRemaining !== 1 ? 's' : ''} to
            reactivate or download your data before it is permanently deleted.
          </span>
        </div>
        <div className="grace-period-actions">
          <Button
            variant="outline-dark"
            size="sm"
            onClick={() => navigate('/dashboard')}
            className="download-btn"
          >
            Download Data
          </Button>
          <Button
            variant="warning"
            size="sm"
            onClick={() => navigate('/select-plan')}
            className="reactivate-btn"
          >
            Reactivate Subscription
          </Button>
        </div>
      </div>
    </Alert>
  );
};

export default GracePeriodBanner;
